module.exports = __webpack_public_path__ + "media/images/basic_logos/export-f50ca61c420b818750dc584a3da10bb9.svg";